var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2721_3300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1754 7.32051L11.8754 4.02051L10.9334 4.96584L13.8 7.83251H4.41138V9.16584H13.8L10.9334 12.0325L11.876 12.9752L15.176 9.67518C15.3309 9.52041 15.4537 9.33665 15.5374 9.13442C15.6212 8.93218 15.6644 8.71542 15.6644 8.49651C15.6644 8.2776 15.6212 8.06084 15.5374 7.8586C15.4537 7.65636 15.3309 7.47261 15.176 7.31784L15.1754 7.32051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.984 14.5C6.984 14.6768 6.91376 14.8464 6.78874 14.9714C6.66371 15.0964 6.49414 15.1667 6.31733 15.1667H2C1.82319 15.1667 1.65362 15.0964 1.5286 14.9714C1.40357 14.8464 1.33333 14.6768 1.33333 14.5V2.5C1.33333 2.32319 1.40357 2.15362 1.5286 2.0286C1.65362 1.90357 1.82319 1.83333 2 1.83333H6.31733C6.49414 1.83333 6.66371 1.90357 6.78874 2.0286C6.91376 2.15362 6.984 2.32319 6.984 2.5V6.05533H8.31733V2.5C8.31733 1.96957 8.10662 1.46086 7.73155 1.08579C7.35647 0.710714 6.84777 0.5 6.31733 0.5L2 0.5C1.46957 0.5 0.960859 0.710714 0.585786 1.08579C0.210714 1.46086 0 1.96957 0 2.5L0 14.5C0 15.0304 0.210714 15.5391 0.585786 15.9142C0.960859 16.2893 1.46957 16.5 2 16.5H6.31733C6.84777 16.5 7.35647 16.2893 7.73155 15.9142C8.10662 15.5391 8.31733 15.0304 8.31733 14.5V10.9447H6.984V14.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2721_3300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignup);
export default __webpack_public_path__ + "static/media/signup.c5ed7d511043c6a58d3a7d18ad7e2bff.svg";
export { ForwardRef as ReactComponent };